export default "__VITE_ASSET__xXnEq8sj__"